import { render, staticRenderFns } from "./friend.vue?vue&type=template&id=5f27be93&scoped=true&"
import script from "./friend.vue?vue&type=script&lang=js&"
export * from "./friend.vue?vue&type=script&lang=js&"
import style0 from "./friend.vue?vue&type=style&index=0&id=5f27be93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f27be93",
  null
  
)

export default component.exports